export default __webpack_public_path__ + "static/media/rabbit.ccfc44c0.png";